/**
 * Subtle parallax on hero/banner background images.
 * Moves background ~30% slower than scroll for depth.
 * Desktop only, respects prefers-reduced-motion.
 */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  if ('ontouchstart' in window && !window.matchMedia('(pointer: fine)').matches) return;

  var SPEED = 0.3;
  var sections = [];
  var ticking = false;

  function gather() {
    sections = [];
    var els = document.querySelectorAll(
      '.hero, .slideshow, .image-banner, [class*="hero"], [class*="banner"]'
    );
    for (var i = 0; i < els.length; i++) {
      var bg = els[i].querySelector('.background-media, .hero__media, .slideshow__media, .banner__media, [class*="background-image"]');
      if (bg) {
        bg.style.willChange = 'transform';
        bg.style.transition = 'none';
        sections.push({ container: els[i], bg: bg });
      }
    }
  }

  function update() {
    for (var i = 0; i < sections.length; i++) {
      var s = sections[i];
      var rect = s.container.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > window.innerHeight) continue;
      var progress = rect.top / window.innerHeight;
      var offset = progress * rect.height * SPEED;
      s.bg.style.transform = 'translate3d(0,' + offset.toFixed(1) + 'px,0)';
    }
    ticking = false;
  }

  function onScroll() {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(update);
    }
  }

  function init() {
    gather();
    if (sections.length > 0) {
      window.addEventListener('scroll', onScroll, { passive: true });
      update();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
